import { Expose } from "class-transformer";

export class CreateClientGroupDto {
  @Expose()
  name: string;

  @Expose()
  clientTypeId?: string;
}
